module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1505-9232f5aaa4156941fe9db830e36915ea.png";